import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import Print from '../print/Print';
import Prints from '../print/Prints';
import Authenticity from '../authenticity/Authenticity';
import Authenticitys from '../authenticity/Authenticitys';
import MountConditions from '../mount_condition/MountConditions';
import MountCondition from '../mount_condition/MountCondition';
import Date_Confidence from '../date_confidence/Date_Confidence';
import Date_Confidences from '../date_confidence/Date_Confidences';
import Support from '../support-table/Support';
import ListSupport from '../support-table/ListSupport';
import Configure from '../configuration/Configure';
import UpdateConfig from '../configuration/UpdateConfig';
import ImgDescFields from '../img-desc-fields/ImgDescFields';
import ListImgFields from '../img-desc-fields/ListImgFields';
import SheetDimension from './dimension/SheetDimension';
import ListSheetDimension from './dimension/ListSheetDimension';
import MountType from './mount_type/MountType';
import MountTypes from './mount_type/MountTypes';
import Locations from './locations/Locations';
import LocationList from './locations/LocationList';
import GeoLoc from './geo_locations/GeoLoc';
import GeoLocList from './geo_locations/GeoLocList';
import Parks from './geo_locations/Parks';
import Park from './geo_locations/Park';
import States from './geo_locations/States';
import State from './geo_locations/State';
import StampList from '../stamp/StampList';
import Stamps from '../stamp/Stamps';
import Signature from '../signature/Signature';
import SignatureList from '../signature/SignatureList';
import Annotations from '../annotations/Annotations';
import AnnotationList from '../annotations/AnnotationList';
import MountTypeChar from './mount_type_char/MountTypeChar';
import MountTypeCharList from './mount_type_char/MountTypeCharList';
import ConceptualWork from './conceptual_work/ConceptualWork';
import ConceptualWorkList from './conceptual_work/ConceptualWorkList';
import SignaturePlacement from './signature_placement/SignaturePlacement';
import SignaturePlacementList from './signature_placement/SignaturePlacementList';
import DminSampleArea from './Dmin_sample_area/DminSampleArea';
import DminSampleAreaList from './Dmin_sample_area/DminSampleAreaList';
import HandWriting from './handwriting/HandWriting';
import HandWritingList from './handwriting/HandWritingList';
import PaperGroupForm from './paper_group/PaperGroupForm';
import PaperGroupList from './paper_group/PaperGroupList';
import PaperFamily from './paper_family/PaperFamily';
import PaperFamilyList from './paper_family/PaperFamilyList';
import StatsList from './stats/StatsList';

const Settings = props => {
  const { section, section_2, id } = useParams();
  const currentTab = () => {
    switch (section) {
      case 'prints-conditions':
        return id ? <Print {...props} /> : <Prints {...props} />;
      case 'support-table':
        return id ? <Support {...props} /> : <ListSupport {...props} />;
      case 'negative-sheet-dimensions':
        return id ? <SheetDimension {...props} /> : <ListSheetDimension {...props} />;
      case 'image-description':
        return id ? <ImgDescFields {...props} /> : <ListImgFields {...props} />;
      case 'authenticity':
        return id ? <Authenticity {...props} /> : <Authenticitys {...props} />;
      case 'mount-condition-type':
        return id ? <MountCondition {...props} /> : <MountConditions {...props} />;
      case 'date-confidence':
        return id ? <Date_Confidence {...props} /> : <Date_Confidences {...props} />;
      case 'configuration':
        return id ? <UpdateConfig {...props} /> : <Configure {...props} />;
      case 'mount-conditions':
        return id ? <MountType {...props} /> : <MountTypes {...props} />;
      case 'object-locations':
        return id ? <Locations {...props} /> : <LocationList {...props} />;
      case 'geographic-locations':
        return id ? <GeoLoc {...props} /> : <GeoLocList {...props} />;
      case 'states':
        return id ? <State {...props} /> : <States {...props} />;
      case 'parks':
        return id ? <Park {...props} /> : <Parks {...props} />;
      case 'stamps':
        return id ? <Stamps {...props} /> : <StampList {...props} />;
      case 'signatures':
        return id ? <Signature {...props} /> : <SignatureList {...props} />;
      case 'annotation-materials':
        return id ? <Annotations {...props} /> : <AnnotationList {...props} />;
      case 'mount-types':
        return id ? <MountTypeChar {...props} /> : <MountTypeCharList {...props} />;
      case 'portfolio-conceptual-works':
        return id ? <ConceptualWork {...props} /> : <ConceptualWorkList {...props} />;
      case 'signature-placement':
        return id ? <SignaturePlacement {...props} /> : <SignaturePlacementList {...props} />;
      case 'dmin-sample':
        return id ? <DminSampleArea {...props} /> : <DminSampleAreaList {...props} />;
      case 'hand-writing':
        return id ? <HandWriting {...props} /> : <HandWritingList {...props} />;
      case 'paper-groups':
        return id ? <PaperGroupForm {...props} /> : <PaperGroupList {...props} />;
      case 'paper-family':
        return id ? <PaperFamily {...props} /> : <PaperFamilyList {...props} />;
      case 'paper-group-stats':
        return <StatsList {...props} />;
      default:
        return <Prints {...props} />;
    }
  };
  return <div>{currentTab()}</div>;
};

export default Settings;
